export default "__VITE_ASSET__CXclaQVg__"